import React from "react";
import { Route } from "react-router-dom";
import { cookieService } from "../_services";
import { STRING_CONSTANTS } from "../utils/constants/stringConstants";
import Login from "../pages/SignIn";
import Terms from "../pages/legal/terms";
import Privacy from "../pages/legal/privacy";
import EmployerProfileCompletion from "../pages/EmployerProfileCompletion";
import SignUp from "../pages/Signup";
import { Data } from "../_services/collections";
import EmployeeProfileCompletion from "../pages/EmployeeProfileCompletion";
import Dashboard from "../pages/Dashboard/dashboard";

// import redirector
import { Redirect } from "react-router-dom";

const PrivateRoute = ({ path, component: Comp, ...rest }) => {
  let user = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.user)
  let isGuest = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.isGuest)
  let isRouteAccountsSignup = window?.location?.href?.includes('accounts/signup') || window?.location?.href?.includes('accounts/affiliate') || window?.location?.href?.includes('ar/affiliate') || window?.location?.href?.includes('interview-simulator/signup') || window?.location?.href?.includes('legal-assist/signup') || window?.location?.href?.includes('hr-simulator/signup') || window?.location?.href?.includes('hr/signup');
  function getComponent(props) {
    if (isGuest && !user) {
      return <Dashboard {...props} />
    }
    else if (isRouteAccountsSignup) {
      return <Comp {...props} />
    }
    else if (!user) {
      // redirect them to the relative /signin dont just render the component cause it does the wrong one
      // DO A REDIRECT
      return <Redirect to="/signin" />
    }
    else if ((user as Data)?.user?.sendOffers === null) {
      return <SignUp {...props} step={7} />
    }
    // else if (!(user as Data)?.user?.isTermsConditionAccepted) {
    //   // console.log('Terms not accepted')
    //   return <Terms {...props} />
    // }
    // else if (!(user as Data)?.user?.isPrivacyPolicyAccepted) {
    //   // console.log('Privacy not accepted', user?.user?.isPrivacyPolicyAccepted)
    //   return <Privacy {...props} />
    // }
    else if (!(user as Data)?.user?.isProfileCompleted && (user as Data)?.user?.isMobileVerified === true) {
      if (user?.user?.type === STRING_CONSTANTS?.userType?.employer) {
        return <EmployerProfileCompletion {...props} />
      }
      if (user?.user?.type === STRING_CONSTANTS?.userType?.employee) {
        return <EmployeeProfileCompletion {...props} />
      }
    }
    else return <Comp {...props} />
  }

  return (
    <Route
      path={path}
      {...rest}
      render={getComponent}
    />
  );
};

export default PrivateRoute